import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-uvod-u-koristenje-programa-fiwe',
  templateUrl: './uvod-u-koristenje-programa-fiwe.component.html',
  styleUrl: './uvod-u-koristenje-programa-fiwe.component.scss',
  standalone: false
})
export class UvodUKoristenjeProgramaFiweComponent implements OnInit {
  safeSrc: SafeResourceUrl;
  link: string = 'https://www.loom.com/embed/e05fde5e60484e6ea435c2f00b85851e?sid=a63e829d-c62b-4a54-9644-8cdab11ac92e'; // URL to open

  constructor(
    private sanitizer: DomSanitizer,
    public bsModalRef: BsModalRef,
  ) { }

  ngOnInit(): void {
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.link);
  }

  forceCloseModal() {
    this.bsModalRef.hide();
  }

}
